import script from "./TwitterClone.vue?vue&type=script&setup=true&lang=js"
export * from "./TwitterClone.vue?vue&type=script&setup=true&lang=js"

import "./TwitterClone.vue?vue&type=style&index=0&id=dfae8388&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfae8388"]])

export default __exports__